export class LeadProductInfoModel{ 
    itemId : number
    minGrade : number
    maxGrade : number
    foodTypeId : number
    valueAdditionOneId : number
    valueAdditionTwoId : number
    valueAdditionThreeId : number
    valueAdditionFourId : number
    valueAdditionFiveId : number
    pouches : number
    cases : number
    caseWeight : number
    netWeight : number
    netAmount : number
    pouchWeight : number
    categoryId : number
    unitPrice : number
    brandId : number
    uomId : number
    minGlaze : number
    MaxGlaze : number
    soakingTime : number
    soakingStyle : string
    styleWeighment : string
    varientId : number
    innerBags : number
    shrimpWeight : number
    masterBrandId : number
    finalPercentage : number
    category : string
    requiredCount : number
    packStyleId : number
    jobCases : number
    reportedCases : number
    palletCapacity : number
    subJobCodeListData : number
    variantCode: string
    uomName: string
    varietyId: number
    varietyName: string
    innerBagSizeId:number
    grouping?:number
    noOfContainers?:number
    confirmedContainers?:number
    packCount?:number
    variantName?:string
    packStyleName?:string
    isSoCreated?: boolean
    leadProduct?:boolean
    priceBasedOn?:number

    constructor(itemId : number, minGrade : number, maxGrade : number, foodTypeId : number, valueAdditionOneId : number, valueAdditionTwoId : number, valueAdditionThreeId : number, valueAdditionFourId : number, valueAdditionFiveId : number, pouches : number, cases : number, caseWeight : number, netWeight : number, netAmount : number, pouchWeight : number, categoryId : number, unitPrice : number, brandId : number, uomId : number, minGlaze : number, MaxGlaze : number, soakingTime : number, soakingStyle : string, styleWeighment : string, varientId : number, innerBags : number, shrimpWeight : number, masterBrandId : number, finalPercentage : number, category : string, requiredCount : number, packStyleId : number, jobCases : number, reportedCases : number, palletCapacity : number, subJobCodeListData : number,variantCode: string,uomName: string,varietyId: number,varietyName: string,innerBagSizeId:number,grouping?:number,noOfContainers?:number,confirmedContainers?:number,packCount?:number,variantName?:string,packStyleName?:string,isSoCreated?: boolean,leadProduct?:boolean,priceBasedOn?:number){
    this.itemId = itemId 
    this.minGrade = minGrade 
    this.maxGrade = maxGrade 
    this.foodTypeId = foodTypeId 
    this.valueAdditionOneId = valueAdditionOneId 
    this.valueAdditionTwoId = valueAdditionTwoId 
    this.valueAdditionThreeId = valueAdditionThreeId 
    this.valueAdditionFourId = valueAdditionFourId 
    this.valueAdditionFiveId = valueAdditionFiveId 
    this.pouches = pouches 
    this.cases = cases 
    this.caseWeight = caseWeight 
    this.netWeight = netWeight 
    this.netAmount = netAmount 
    this.pouchWeight = pouchWeight 
    this.categoryId = categoryId 
    this.unitPrice = unitPrice 
    this.brandId = brandId 
    this.uomId = uomId 
    this.minGlaze = minGlaze 
    this.MaxGlaze = MaxGlaze 
    this.soakingTime = soakingTime 
    this.soakingStyle = soakingStyle 
    this.styleWeighment = styleWeighment 
    this.varientId = varientId 
    this.innerBags = innerBags 
    this.shrimpWeight = shrimpWeight 
    this.masterBrandId = masterBrandId 
    this.finalPercentage = finalPercentage 
    this.category = category 
    this.requiredCount = requiredCount 
    this.packStyleId = packStyleId 
    this.jobCases = jobCases 
    this.reportedCases = reportedCases 
    this.palletCapacity = palletCapacity 
    this.subJobCodeListData = subJobCodeListData 
    this.variantCode = variantCode
    this.uomName = uomName
    this.varietyId = varietyId
    this.varietyName = varietyName
    this.innerBagSizeId = innerBagSizeId
    this.grouping = grouping
    this.noOfContainers = noOfContainers
    this.confirmedContainers = confirmedContainers
    this.packCount = packCount
    this.packStyleName = packStyleName
    this.variantName = variantName
    this.isSoCreated = isSoCreated
    this.leadProduct = leadProduct
    this.priceBasedOn = priceBasedOn
    }
}